export default {
  obraID: {
    value: null,
    required: true,
    state: null
  },
  servicoAnaliseTecID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  observacao: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/tecanalysisna/tecanalysisna-form.js